import { render, staticRenderFns } from "./preImage.vue?vue&type=template&id=3b6550f0&scoped=true"
import script from "./preImage.vue?vue&type=script&lang=js"
export * from "./preImage.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./preImage.vue?vue&type=style&index=0&id=3b6550f0&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3b6550f0",
  "9b349ab8"
  
)

export default component.exports